<template>
  <div class="dynamic-yield-observer" />
</template>

<script>

/**
 * Vue: Dynamic yield observer (dynamic-yield-observer)
 * -----------------------------------------------------------------------------
 * Dynamic Yield observer.
 * - Observes mutations to run DY tests.
 *
 */
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DynamicYieldObserver',

  data() {
    return {
      tests: [
        // main-collection.vue
        'dy-plp-cards-use-flat-image-first',
        'dy-plp-show-atc',
        // main-product.vue
        'dy-gallery-horizontal-scroll',
        'dy-show-gallery-video',
        'dy-gallery-mobile-arrows',
        // quick-add-success.vue
        'dy-atc-success-hide-view-cart-btn',
        // swiper-gallery-carousel.vue
        'dy-swiper-carousel',
        // site-header.vue
        'dy-slide-out-mobile-drawer',
      ],
    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      dyTests: (state) => state['dynamic-yield'].tests,
    }),
  },

  mounted() {
    this.tests.forEach((test) => {
      const triggerElement = document.querySelector(`.${test}`)

      if (triggerElement) {
        this.setTest(test)
      }
    })

    this.runMutationObserver()
  },

  methods: {

    /**
     * Map Vuex actions.
     */
    ...mapActions({
      setTest: 'dynamic-yield/setTest',
    }),

    /**
     * Run mutation observer.
     * - Watches for elements being added by DY.
     */
    runMutationObserver() {
      const observerConfig = {
        attributes: true,
        childList: true,
        characterData: true,
      }

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (mutation.type !== 'childList' || !mutation.addedNodes.length) {
            continue
          }

          this.tests.forEach((test) => {
            if (this.dyTests.includes(test)) {
              return
            }

            const triggerElement = document.querySelector(`.${test}`)

            if (triggerElement) {
              this.setTest(test)
              window.console.log('DY Test Trigger', test)
            }
          })
        }
      })

      observer.observe(document.body, observerConfig)
    },
  },
}
</script>
